// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32LJC","left":"styles_left__2VgHW"};